import React from "react";

const DotPattern = ({ variant = "dark" }) => {
  const isLight = variant === "light";
  const patternId = isLight ? "loginDotGridLight" : "loginDotGrid";
  const fill = isLight ? "rgba(0,123,255,0.07)" : "rgba(255,255,255,0.2)";

  return (
    <svg
      className={`login-dots${isLight ? " login-dots--light" : ""}`}
      viewBox="0 0 800 900"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <defs>
        <pattern id={patternId} x="0" y="0" width="28" height="28" patternUnits="userSpaceOnUse">
          <circle cx="1.5" cy="1.5" r="0.8" fill={fill} />
        </pattern>
      </defs>
      <rect width="800" height="900" fill={`url(#${patternId})`} />
    </svg>
  );
};

export default DotPattern;
